export { S as SocialLoginResponseStatus } from '../chuck/SocialLoginResponseStatus-BP1cpX8W.js';
export { G as GoogleLoginUxMode } from '../chuck/GoogleLoginUxMode-CI3mpvZT.js';

var LoginSuccessResponseStatus = /*#__PURE__*/ function(LoginSuccessResponseStatus) {
    LoginSuccessResponseStatus[LoginSuccessResponseStatus["Success"] = 0] = "Success";
    LoginSuccessResponseStatus[LoginSuccessResponseStatus["Fail"] = 1] = "Fail";
    LoginSuccessResponseStatus[LoginSuccessResponseStatus["Error"] = 2] = "Error";
    LoginSuccessResponseStatus[LoginSuccessResponseStatus["NotImplemented"] = 3] = "NotImplemented";
    return LoginSuccessResponseStatus;
}({});

var SocialType = /*#__PURE__*/ function(SocialType) {
    SocialType[SocialType["FACEBOOK"] = 0] = "FACEBOOK";
    SocialType[SocialType["GOOGLE"] = 1] = "GOOGLE";
    SocialType[SocialType["APPLE"] = 2] = "APPLE";
    SocialType[SocialType["WECHAT"] = 3] = "WECHAT";
    SocialType[SocialType["KAKAO"] = 4] = "KAKAO";
    SocialType[SocialType["LINE"] = 5] = "LINE";
    SocialType[SocialType["WHATSAPP"] = 6] = "WHATSAPP";
    return SocialType;
}({});

var PartnerCenterSignUpType = /*#__PURE__*/ function(PartnerCenterSignUpType) {
    PartnerCenterSignUpType[PartnerCenterSignUpType["Unknown"] = 0] = "Unknown";
    PartnerCenterSignUpType[PartnerCenterSignUpType["Affiliate"] = 1] = "Affiliate";
    PartnerCenterSignUpType[PartnerCenterSignUpType["Enterprise"] = 2] = "Enterprise";
    PartnerCenterSignUpType[PartnerCenterSignUpType["TravelAgent"] = 3] = "TravelAgent";
    PartnerCenterSignUpType[PartnerCenterSignUpType["Corporate"] = 4] = "Corporate";
    return PartnerCenterSignUpType;
}({});

var MFAOperationCode = /*#__PURE__*/ function(MFAOperationCode) {
    MFAOperationCode["ViewUPC"] = "0";
    MFAOperationCode["AccessFinance"] = "1";
    MFAOperationCode["GuestPIIInfo"] = "3";
    MFAOperationCode["WalletAuthentication"] = "10";
    MFAOperationCode["ResetPin"] = "11";
    MFAOperationCode["WalletStatement"] = "13";
    MFAOperationCode["SCAWithdraw"] = "20";
    MFAOperationCode["PayWithWallet"] = "30";
    return MFAOperationCode;
}({});

var CountryCode = /*#__PURE__*/ function(CountryCode) {
    CountryCode["CN"] = "CN";
    return CountryCode;
}({});
var CHINA_CALLING_CODE = '+86';

var LoginMethodType = /*#__PURE__*/ function(LoginMethodType) {
    LoginMethodType["Phone"] = "Phone";
    LoginMethodType["SmsPhone"] = "SmsPhone";
    LoginMethodType["Email"] = "Email";
    return LoginMethodType;
}({});

export { CHINA_CALLING_CODE, CountryCode, LoginMethodType, LoginSuccessResponseStatus, MFAOperationCode, PartnerCenterSignUpType, SocialType };
